module.exports = __webpack_public_path__ + "files/6f37bbf8bf1801a9f153d703588b471a.png";